import { render } from "./Pet.vue?vue&type=template&id=2086b369"
import script from "./Pet.vue?vue&type=script&lang=js"
export * from "./Pet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__